export default __webpack_public_path__ + "static/media/CsvIcon.a35cc9e6.svg";